import Vue from "vue";
import Vuex from "vuex";
import metaModule from "./modules/metaModule";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    metaModule
  },
});
